import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import SendIcon from "@mui/icons-material/Send";
import PropTypes from "prop-types";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { createSafeFactLink, createSafeMoveLink } from "./actions";

const InvoiceStatusButtons = ({ status, plannedFor, palette, project, invoice, user, isForExcelExport }) => {

    const [showModal, setShowModal] = useState(false);
    const [showCalendarModal, setShowCalendarModal] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);

    const isSent = status === 3;
    const isPendingPastDate = status === 0 && moment(plannedFor).isBefore(moment());
    const isPendingFutureDate = status === 0 && moment(plannedFor).isAfter(moment());

    const handleOpenModal = () => {
        if (!isSent) setShowModal(true);
    };
    const handleCloseModal = () => setShowModal(false);

    const handleOpenCalendarModal = () => {
        if (!isSent) {
            setShowCalendarModal(true);
            handleCloseModal();
        }
    };
    const handleCloseCalendarModal = () => setShowCalendarModal(false);

    const handleDateChange = (date) => setSelectedDate(date);

    const handleDateSubmit = () => {
        const newMoveLink = createSafeMoveLink(project, invoice, selectedDate, user);

        if (newMoveLink.startsWith("Error")) {
            alert(newMoveLink);
        } else {
            window.location.href = newMoveLink;
            handleCloseCalendarModal();
        }
    };

    const modalContent = (
        <Modal show={showModal} onHide={handleCloseModal}>
            <Modal.Header closeButton>
                <Modal.Title>{project.project_name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {invoice.projects_invoice_terms_commentary}
                <Button variant="link" href={createSafeFactLink(project, invoice)} disabled={isSent}>
                    Verzenden
                </Button>
                <Button variant="link" onClick={handleOpenCalendarModal} disabled={isSent}>
                    Verzetten
                </Button>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                    Sluiten
                </Button>
            </Modal.Footer>
        </Modal>
    );

    const calendarModalContent = (
        <Modal show={showCalendarModal} onHide={handleCloseCalendarModal}>
            <Modal.Header closeButton>
                <Modal.Title>Selecteer een nieuwe datum</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label>Kies een nieuwe datum:</Form.Label>
                    <DatePicker
                        selected={selectedDate}
                        onChange={handleDateChange}
                        dateFormat="dd MMMM yyyy"
                        className="form-control"
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseCalendarModal}>
                    Annuleren
                </Button>
                <Button variant="primary" onClick={handleDateSubmit} disabled={!selectedDate || isSent}>
                    Verzenden
                </Button>
            </Modal.Footer>
        </Modal>
    );

    return (
        <div>
            <SendIcon
                className={`cursor-pointer ${isSent ? "disabled-icon" : ""}`}
                style={{ color: isSent ? palette.green : isPendingPastDate ? palette.red : palette.blue }}
                onClick={handleOpenModal}
            />
            {modalContent}
            {calendarModalContent}
        </div>
    );
};

InvoiceStatusButtons.propTypes = {
    status: PropTypes.number.isRequired,
    plannedFor: PropTypes.string.isRequired,
    palette: PropTypes.object,
    project: PropTypes.object.isRequired,
    invoice: PropTypes.object.isRequired,
    isForExcelExport: PropTypes.bool,
};

InvoiceStatusButtons.defaultProps = {
    palette: { green: "#28a745", red: "#dc3545", blue: "#007bff" },
    isForExcelExport: false,
};

export default InvoiceStatusButtons;
